import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-terms',
  templateUrl: './company-terms.component.html',
  styleUrls: ['./company-terms.component.scss']
})
export class CompanyTermsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
